import {
  Component,    
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { register } from 'swiper/element/bundle';
import { RouterOutlet } from '@angular/router';
import { Header } from '../../../core/components/header/header';
import { Footer } from '../../../core/components/footer/footer';

register();

@Component({
  selector: 'app-landing',
  imports: [RouterOutlet, Header, Footer],
  templateUrl: './landing.html',
  styles: ``,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class Landing {

}
